import * as React from 'react'

import { cn } from '@/lib/utils'

export interface InputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'prefix'> {
  isInvalid?: boolean
  prefix?: React.ReactNode
  suffix?: React.ReactNode
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, isInvalid, prefix, suffix, ...props }, ref) => {
    if (prefix || suffix) {
      return (
        <div
          className={cn(
            'flex w-full items-center rounded-[16px] border !border-monochrome-120 !bg-monochrome-3-60 !text-monochrome-1 px-3 has-[:focus-visible]:outline-none has-[:focus-visible]:!border-accent-1 has-[:disabled]:cursor-not-allowed has-[:disabled]:opacity-50',
            isInvalid &&
              '!border-accent-3 has-[:focus-visible]:!border-accent-3',
            className,
          )}
        >
          {prefix && <div className="mr-2 flex-shrink-0">{prefix}</div>}
          <input
            type={type}
            className="flex-1 bg-transparent text-button-m outline-none placeholder:text-monochrome-120 disabled:cursor-not-allowed"
            ref={ref}
            {...props}
          />
          {suffix && <div className="ml-2 flex-shrink-0">{suffix}</div>}
        </div>
      )
    }

    return (
      <input
        type={type}
        className={cn(
          'flex h-[44px] w-full rounded-[16px] border !border-monochrome-120 !bg-monochrome-3-60 !text-monochrome-1 px-3 py-2 text-button-m file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-monochrome-120 focus-visible:outline-none focus-visible:!border-accent-1 disabled:cursor-not-allowed disabled:opacity-50',
          isInvalid && '!border-accent-3 focus-visible:!border-accent-3',
          className,
        )}
        ref={ref}
        {...props}
      />
    )
  },
)
Input.displayName = 'Input'

export { Input }
